/**
 * Export loadData calls from ducks modules of different containers
 */
import { loadData as AuthenticationPageLoader } from './AuthenticationPage/AuthenticationPage.duck';
import { loadData as LandingPageLoader } from './LandingPage/LandingPage.duck';
import { checkoutSetInitialValues } from './CheckoutPage/checkoutSetInitialValues';
import { loadData as BillingDetailsPageLoader } from './BillingDetailsPage/BillingDetailsPage.duck';
import { loadData as CMSPageLoader } from './CMSPage/CMSPage.duck';
import { loadData as ContactDetailsPageLoader } from './ContactDetailsPage/ContactDetailsPage.duck';
import { loadData as EditListingPageLoader } from './EditListingPage/EditListingPage.duck';
import { loadData as EditListingTabShortcutPageLoader } from './EditListingTabShortcutPage/EditListingTabShortcutPage.duck';
import { loadData as EmailVerificationPageLoader } from './EmailVerificationPage/EmailVerificationPage.duck';
import { loadData as InboxPageLoader } from './InboxPage/InboxPage.duck';
import { loadData as ListingPageLoader } from './ListingPage/ListingPage.duck';
import { loadData as ManageListingsPageLoader } from './ManageListingsPage/ManageListingsPage.duck';
import { loadData as FavouriteListingsPageLoader } from './FavouriteListingsPage/FavouriteListingsPage.duck';
import { loadData as PaymentMethodsPageLoader } from './PaymentMethodsPage/PaymentMethodsPage.duck';
import { loadData as PrivacyPolicyPageLoader } from './PrivacyPolicyPage/PrivacyPolicyPage.duck';
import { loadData as ProfilePageLoader } from './ProfilePage/ProfilePage.duck';
import { loadData as SearchPageLoader } from './SearchPage/SearchPage.duck';
import { loadData as SeoLandingPageLoader } from './SeoLandingPage/SeoLandingPage.duck';
import { loadData as StripePayoutPageLoader } from './StripePayoutPage/StripePayoutPage.duck';
import { loadData as TermsOfServicePageLoader } from './TermsOfServicePage/TermsOfServicePage.duck';
import { loadData as BarbacoaPageLoader } from './Barbacoa/BarbacoaPage.duck';
import {
  loadData as TransactionPageLoader,
  setInitialValues as TransactionPageInitialValues,
} from './TransactionPage/TransactionPage.duck';

import { loadData as CostCalculatorPageLoader } from '../containers/CostCalculationPage/CostCalculationPage.duck';

import { loadData as OnHoldListingsPageLoader } from './OnholdListingPage/OnholdingListingsPage.duck';
import { loadData as UpcomingListingsPageLoader } from './UpcomingListingsPage/UpcomingListingsPage.duck';
import { loadData as PastListingsPageLoader } from './PastListingsPage/PastListingsPage.duck';
import { loadData as ReservaAntiguesPageLoader } from './ReservaAntiguesPage/ReservaAntiguesPage.duck';
import { loadData as IngresosPageLoader } from './IngresosPage/IngresosPage.duck';
import { loadData as DashboardPageLoader } from './DashboardPage/DashboardPage.duck';
import { loadData as ExternalBookingPaymentPageLoader } from './ExternalBookingPaymentPage/ExternalBookingPaymentPage.duck';

const getPageDataLoadingAPI = () => {
  return {
    AuthenticationPage: {
      loadData: AuthenticationPageLoader,
    },
    EmailFirstLoginPage: {
      loadData: AuthenticationPageLoader,
    },
    LandingPage: {
      loadData: LandingPageLoader,
    },
    CheckoutPage: {
      setInitialValues: checkoutSetInitialValues,
    },
    BillingDetailsPage: {
      loadData: BillingDetailsPageLoader,
    },
    CMSPage: {
      loadData: CMSPageLoader,
    },
    ContactDetailsPage: {
      loadData: ContactDetailsPageLoader,
    },
    EditListingPage: {
      loadData: EditListingPageLoader,
    },
    EditListingTabShortcutPage: {
      loadData: EditListingTabShortcutPageLoader,
    },
    EmailVerificationPage: {
      loadData: EmailVerificationPageLoader,
    },
    InboxPage: {
      loadData: InboxPageLoader,
    },
    ListingPage: {
      loadData: ListingPageLoader,
    },
    FavouriteListingsPage: {
      loadData: FavouriteListingsPageLoader,
    },
    ManageListingsPage: {
      loadData: ManageListingsPageLoader,
    },
    PaymentMethodsPage: {
      loadData: PaymentMethodsPageLoader,
    },
    PrivacyPolicyPage: {
      loadData: PrivacyPolicyPageLoader,
    },
    BarbacoaPage: {
      loadData: BarbacoaPageLoader,
    },
    ProfilePage: {
      loadData: ProfilePageLoader,
    },
    SearchPage: {
      loadData: SearchPageLoader,
    },
    SeoLandingPage: {
      loadData: SeoLandingPageLoader,
    },
    StripePayoutPage: {
      loadData: StripePayoutPageLoader,
    },
    TermsOfServicePage: {
      loadData: TermsOfServicePageLoader,
    },
    TransactionPage: {
      loadData: TransactionPageLoader,
      setInitialValues: TransactionPageInitialValues,
    },
    OnholdListingsPage: {
      loadData: OnHoldListingsPageLoader,
    },
    UpcomingListingsPage: {
      loadData: UpcomingListingsPageLoader,
    },
    PastListingsPage: {
      loadData: PastListingsPageLoader,
    },
    ReservaAntiguesPage: {
      loadData: ReservaAntiguesPageLoader,
    },
    IngresosPage: {
      loadData: IngresosPageLoader,
    },
    DashboardPage: {
      loadData: DashboardPageLoader,
    },
    ExternalBookingPaymentPage: {
      loadData: ExternalBookingPaymentPageLoader,
    },
    CostCalculatorPage: {
      loadData: CostCalculatorPageLoader,
    },
  };
};

export default getPageDataLoadingAPI;
